import React, { useRef } from "react";
import { images } from "../../assets/images";
import { sidebarOptions } from "./sidebarOptions";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useClickAway } from "react-use";
import { motion } from "framer-motion";

const DashboardSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dashboardRef = useRef();
  const { dashboardVisible, setDashboardVisible } = useAuth();

  useClickAway(dashboardRef, () => {
    setDashboardVisible(false);
  });

  const {
    user: { userLabel },
    setCurrentTabSelect,
  } = useAuth();

  const onClickHelp = () => {
    navigate("/helpcenter");
    setDashboardVisible(false);
  };

  const onClickLogo = () => {
    navigate("/");
    setDashboardVisible(false);
  };

  if (!dashboardVisible) {
    return null;
  }

  return (
    <div className="sidebar-container">
      <div
        className="sidebar-wrapper"
        ref={dashboardRef}
        style={{
          width: "82%",
        }}
        // animate={{ width: dashboardVisible ? "82%" : "0%" }}

        // transition={{ duration: 0.3 }}
      >
        <img
          src={images.mainLogo}
          className="dashboard-logo cursor-pointer"
          alt="keventer's logo"
          onClick={onClickLogo}
        />
        <div className="sidebar-options">
          {sidebarOptions.map((item, index) => {
            const isActive =
              item.link === "/"
                ? location.pathname === item.link
                : location.pathname.includes(item.link);

            if (!item.showTo.includes(userLabel)) {
              return null;
            }
            return (
              <Link
                to={item.link}
                key={"option-" + index}
                onClick={() => {
                  setDashboardVisible(false);
                  setCurrentTabSelect({ title: "View All Request", id: 1 });
                }}
              >
                <div
                  className={`sidebar-option ${
                    isActive ? "sidebar-option-active" : ""
                  }`}
                >
                  <div className="sidebar-option-icon-wrapper">
                    <img src={item.icon} alt="sidebar option icon" />
                  </div>
                  <div
                    className={`sidebar-option-title font-size-small ${
                      isActive ? "font-family-medium" : ""
                    }`}
                  >
                    {item.title}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        <div className="sidebar-footer">
          <button
            className="help-button font-size-small font-family-medium"
            onClick={onClickHelp}
          >
            Help Center
          </button>
          <div className="font-size-small text-[var(--ultraLightGray)] mt-6">
            &copy; Powered by CorePeelers
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSidebar;
